module.exports = __webpack_public_path__ + "static/media/Experten02.7cc92a83.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/Experten02.jpg
// module id = 357
// module chunks = 0